import { useEffect } from 'react'

const POLL_INTERVAL = 24 * 60 * 60 * 1000 // 24 hours

const useUpdateChecker = () => {
  useEffect(() => {
    // Get the version embedded at build time
    const currentVersion = process.env.REACT_APP_BUILD_VERSION

    // Skip in development mode (no build version)
    if (!currentVersion) {
      return
    }

    const checkForUpdate = async () => {
      try {
        // Fetch version.json with cache-busting timestamp
        const response = await fetch(`/version.json?t=${Date.now()}`)

        if (!response.ok) {
          // Silently ignore errors (offline, 404, etc.)
          return
        }

        const data = await response.json()

        // If version differs, reload the page
        if (data.version && data.version !== currentVersion) {
          console.log('New version detected, reloading...')
          window.location.reload()
        }
      } catch (error) {
        // Silently ignore errors (network issues, parsing errors, etc.)
      }
    }

    // Check when user returns to tab
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkForUpdate()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    // Also poll every 24 hours for long-open tabs
    const intervalId = setInterval(checkForUpdate, POLL_INTERVAL)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      clearInterval(intervalId)
    }
  }, [])
}

export default useUpdateChecker
